import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import {Router} from '@angular/router';
import {PersonLoginService} from '../services/person-login-service';
import { EntitySearchComponent } from '../entity/entity-search.component';

@Component({
    selector: 'order-master',
    templateUrl: './order-master.component.html',
    styleUrls: ['./order-master.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [EntitySearchComponent]
})
export class OrderMasterComponent {
  private router = inject(Router);
  private personLoginService = inject(PersonLoginService);


  public entityName = 'CONTRACT';
  public showAllFilters: boolean = false;

  constructor
  () {
    if (this.personLoginService.isOutsideEngineer()) {
      this.router.navigate(['ratings']);
    }
    this.showAllFilters = this.personLoginService.isInternalOrRsm();
  }

  public goToDetail(entityHeader: any) {
    if (entityHeader) {
      this.router.navigate(['orders', entityHeader.id.entityId, entityHeader.id.entityRevision]);
    }
  }

  public goToRecentReleases(searchOrgUnitId: any) {
    this.router.navigate(['recentReleases', searchOrgUnitId]);
  }

}

